"use strict";

exports.__esModule = true;
exports.DeviceListScreen = void 0;
var _reactRouterCompat = require("../../../Utils/reactRouterCompat");
var _react = _interopRequireWildcard(require("react"));
var _styledComponents = require("styled-components");
var _reactRouterDom = require("react-router-dom");
var _Core = require("../../Core");
var _API = require("../../API");
var _DeviceList = require("../DeviceList");
var _MasterDetailView = require("../../Core/MasterDetailView");
var _App = require("../../App");
var _System = require("../../../System");
var _UpdateDeviceScreen = require("../UpdateDeviceScreen");
var _DeviceScreenToolbar = require("../DeviceScreenToolbar");
var _DeviceCollection = require("../DeviceCollection");
var _dec, _class, _DeviceListScreen;
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, "default": e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
function _inheritsLoose(t, o) { t.prototype = Object.create(o.prototype), t.prototype.constructor = t, _setPrototypeOf(t, o); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
/**
 * List screen for devices
 */
var DeviceListScreen = exports.DeviceListScreen = (_dec = _DeviceCollection.DeviceCollectionContext.withContext, (0, _Core.withTranslator)(_class = (0, _styledComponents.withTheme)(_class = _dec(_class = (_DeviceListScreen = /*#__PURE__*/function (_Component) {
  function DeviceListScreen() {
    var _this;
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _Component.call.apply(_Component, [this].concat(args)) || this;
    _this.container = null;
    _this.state = {
      searchTerm: "",
      filterOnEnabled: true,
      width: 0,
      height: 0
    };
    _this.registerContainer = function (container) {
      _this.container = container;
    };
    _this.handleSelect = function (selected) {
      var _this$props = _this.props,
        history = _this$props.history,
        id = _this$props.match.params.id;
      if (selected === id || selected !== undefined) {
        return;
      }
      history.push((0, _System.getScreenLocation)("DeviceList"));
    };
    return _this;
  }
  _inheritsLoose(DeviceListScreen, _Component);
  var _proto = DeviceListScreen.prototype;
  _proto.componentDidUpdate = function componentDidUpdate() {
    var _this$state = this.state,
      height = _this$state.height,
      width = _this$state.width;
    if (this.container) {
      var boundingRect = this.container.getBoundingClientRect();
      if (height !== boundingRect.height && width !== boundingRect.width) {
        // eslint-disable-next-line react/no-did-update-set-state
        this.setState({
          height: boundingRect.height,
          width: boundingRect.width
        });
      }
    }
  };
  _proto.render = function render() {
    var _this2 = this;
    var _this$props2 = this.props,
      translator = _this$props2.translator,
      deviceCollection = _this$props2.deviceCollection,
      theme = _this$props2.theme,
      id = _this$props2.match.params.id;
    var translate = translator.translate;
    var _this$state2 = this.state,
      searchTerm = _this$state2.searchTerm,
      filterOnEnabled = _this$state2.filterOnEnabled,
      height = _this$state2.height,
      width = _this$state2.width;
    return /*#__PURE__*/_react["default"].createElement(_Core.Screen, {
      title: translate("LegacyDeviceListScreen.title", "Devices")
    }, /*#__PURE__*/_react["default"].createElement(_MasterDetailView.MasterDetailView, {
      selected: id,
      onSelect: this.handleSelect,
      renderMaster: function renderMaster() {
        return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement(_App.AppNavbar, {
          title: translate("LegacyDeviceListScreen.navbar.title", "Devices")
        }), /*#__PURE__*/_react["default"].createElement(_API.CollectionSearcher, {
          collection: deviceCollection,
          term: searchTerm,
          filterPredicate: function filterPredicate(item) {
            return item.enabled === filterOnEnabled;
          }
        }, function (_ref) {
          var data = _ref.data,
            error = _ref.error;
          if (error) {
            return /*#__PURE__*/_react["default"].createElement(_Core.UhOh, {
              error: error
            });
          }
          if (!data) {
            return /*#__PURE__*/_react["default"].createElement(_Core.Spinner, null);
          }
          return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement(_Core.ErrorBoundary, null, /*#__PURE__*/_react["default"].createElement(_DeviceScreenToolbar.DeviceScreenToolbar, {
            enabledFilterOn: filterOnEnabled,
            onChangeEnabledToggle: function onChangeEnabledToggle(isEnabled) {
              return _this2.setState({
                filterOnEnabled: isEnabled
              });
            },
            searchTerm: searchTerm,
            count: data.length,
            onChange: function onChange(searchTerm) {
              return _this2.setState({
                searchTerm: searchTerm
              });
            },
            devices: data
          }), /*#__PURE__*/_react["default"].createElement("div", {
            ref: _this2.registerContainer,
            style: {
              height: "calc(100vh - " + theme.NavbarHeight + " - " + theme.ToolbarHeight + ")",
              width: "100%"
            }
          }, height && width ? /*#__PURE__*/_react["default"].createElement(_DeviceList.DeviceList, {
            items: data,
            height: height,
            width: width
          }) : null)));
        }));
      },
      renderDetail: function renderDetail() {
        return /*#__PURE__*/_react["default"].createElement(_reactRouterCompat.RootRoutes, null, /*#__PURE__*/_react["default"].createElement(_reactRouterDom.Route, {
          path: (0, _System.getScreenPath)("UpdateDevice"),
          element: /*#__PURE__*/_react["default"].createElement(_reactRouterCompat.CompatRoute, {
            component: _UpdateDeviceScreen.UpdateDeviceScreen
          })
        }));
      }
    }));
  };
  return DeviceListScreen;
}(_react.Component), _DeviceListScreen.defaultProps = {
  devices: undefined,
  match: undefined,
  translator: undefined
}, _DeviceListScreen)) || _class) || _class) || _class);